
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';
import { IFourPartsCard } from './IFourPartsCard';
import SimpleCard from '../simpleCard/simpleCard';

export default function FourPartsCard({ amount, companyName, date, onClick, logo }: IFourPartsCard) {
    // src=`data:image/png;base64,${logo}`
    return (
        <>
            <SimpleCard>
                <div onClick={() => onClick()}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                        <div style={{ alignContent: "flex-start" }}>
                            <span style={{ fontSize: "1rem", fontWeight: "bold", paddingRight: "5px" }}>{amount?.toLocaleString()} </span>
                            <span style={{ fontSize: "0.8rem", }}>ریال </span>
                        </div>
                        <div style={{ alignContent: "flex-end" }}>
                            <span style={{ fontSize: "0.7rem", color: "text-[#212121]" }}> {date} </span>
                        </div>
                    </div>
                    <hr style={{ color: '#D7DBEC', paddingBottom: "10px", borderTop: "2px solid" }} />
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", paddingBottom: "10px" }}>
                        <div style={{ alignContent: "flex-start" }}>

                            <span style={{ fontSize: "1rem", fontWeight: "medium", paddingRight: "5px" }}> <img style={{ width: "20px", height: "20px", display: "inline-block" }} src={`data:image/png;base64, ${logo}`} />&nbsp;  {companyName}</span>
                        </div>
                        <div style={{ alignContent: "flex-end" }}>
                            <span style={{ fontSize: "0.7rem", color: "text-[#212121]", fontWeight: "bold", cursor: 'pointer' }} > <ShoppingBasketOutlinedIcon sx={{ fontSize: "13px" }} /> &nbsp; جزییات خرید </span>
                        </div>
                    </div>
                </div>
            </SimpleCard>
        </>
    );
}
